export const queryKeys = {
  user: "user",
  category: "category",
  store: "store",
  products: "products",
  questionnaire: "questionnaire",
  onboardingResponse: "onboardingResponse",
  assessment: "assessment",
  iassessment: "iassessment",
  assessmentResponse: "assessmentResponse",
  userAssessmentResponse: "userAssessmentResponse",
  users: "users",
  training: "training",
  color: "color",
  newsletter: "newsletter",
  service: "service",
  courses: "courses",
  batch: "batch",
  team: "team",
  transaction: "transaction",
  key: "key",
  sectiona: "sectiona",
  iassessmentResponse: "iassessmentResponse",
  sectionAResponse: "sectionAResponse",
  blog: "blog",
  accountability: "accountability",
  myJourney: "myJourney",
};
